var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('api-header',{attrs:{"user-info":_vm.userInfo}}),_c('div',{staticClass:"main",style:({'height': _vm.pageHeight + 'px'})},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.pageName))]),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }